import React from 'react'
import PropTypes from 'prop-types'

import { useSingleSelect } from './_hooks'
import { Select00 } from './_elements'
import SubQuestionTitle from '../SubQuestionTitle'
const SingleSelect = ({ component, step, updatedSelected }) => {
  const [isSelected, handleSelect] = useSingleSelect({ component, step })

  const Component = (() => {
    switch (component.type) {
      default:
        return Select00
    }
  })()

  return (
    <>
      {component?.subQuestion ? (
        <SubQuestionTitle subQuestion={component.subQuestion} />
      ) : null}
      <Component
        component={component}
        step={step}
        handleSelect={handleSelect}
        isSelected={isSelected}
        updatedSelected={updatedSelected}
      />
    </>
  )
}

SingleSelect.propTypes = {
  component: PropTypes.object.isRequired,
  updatedSelected: PropTypes.any
}

export default SingleSelect
